import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestSection() {
  const latestComics = [...comics].sort((a, b) =>
    new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime()
  ).slice(0, 8);

  return (
    <section className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between mb-10">
          <div>
            <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-900 mb-2">
              最新更新
            </h2>
            <p className="text-sm text-foreground-500">每日更新最新章节，精彩内容不容错过</p>
          </div>
          <Link
            to="/category/all"
            className="hidden sm:flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors whitespace-nowrap cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 gap-5 md:gap-6" data-product-shop="">
          {latestComics.map((comic) => (
            <Link
              key={comic.id}
              to={`/article/${comic.id}`}
              className="group cursor-pointer"
            >
              <div className="relative aspect-[3/4] rounded-lg overflow-hidden mb-3 bg-background-200">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-400"
                  title={comic.title}
                  loading="lazy"
                />
                <div className="absolute top-2 left-2">
                  <span className={`text-xs font-medium px-2 py-0.5 rounded-full ${
                    comic.status === '连载中'
                      ? 'bg-accent-500 text-background-50'
                      : 'bg-secondary-500 text-background-50'
                  }`}>
                    {comic.status}
                  </span>
                </div>
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-3">
                  <p className="text-xs text-background-100/80">
                    更新至第{comic.chapters}话 · {comic.updatedAt}
                  </p>
                </div>
              </div>
              <h3 className="text-sm font-semibold text-foreground-900 group-hover:text-primary-600 transition-colors line-clamp-1 mb-1">
                {comic.title}
              </h3>
              <p className="text-xs text-foreground-500">{comic.author} · {comic.category}</p>
            </Link>
          ))}
        </div>

        <div className="mt-8 text-center sm:hidden">
          <Link
            to="/category/all"
            className="inline-flex items-center gap-1.5 text-sm font-medium text-primary-600 hover:text-primary-700 transition-colors cursor-pointer"
          >
            查看全部 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>
      </div>
    </section>
  );
}